import { render, staticRenderFns } from "./details-item.vue?vue&type=template&id=460a254d"
import script from "./details-item.vue?vue&type=script&lang=js"
export * from "./details-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports